import React, {useEffect} from 'react';
import ReactGA from 'react-ga';
import { useState } from 'react';
import { Redirect} from "react-router";
import Question from "../Components/Question";
import Loading from "../Components/Loading";


const analyticsId = 'G-EK0Y8CQQZH';

declare const window: any;
declare const gtag: any;
declare const fbq: any;


export const initGA = () => {
    const { title } = window.document;
    const { href, pathname } = window.location;

    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());
};

initGA();


const QuestionPage = () => {

    const [type, setType] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const getType = (type: string):void => {
        setType(type);
        gtag('event', 'Test_Result' , {
            event_category: 'Test_Result',
            event_label: type,
            value: type
        });
        gtag('event', type , {
            event_category: 'Test_Result',
            event_label: type,
        });
        fbq('track', 'Test_Result' , {
            value: type
        });
        setTimeout(() => setIsLoading(true), 2000);
    };
    return (
        <section>
            {
                (type === undefined ? (
                    <Question getType={(type) => getType(type)}/>
                ) : (
                    (!isLoading) ? (
                        <Loading/>
                    ) : (
                        <Redirect to={`/result/${type}`}/>
                    )
                ))
            }
        </section>
    );
};

export default QuestionPage;